import { getFetch, postFetchWithBody, postFetchWithToken } from "../../utils/fetch";

async function getDelays(page) {
  const data = await getFetch(`/delays?page=${page}`);
  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
async function storeDelays(form) {
  if (form.get('title') === '') {
    return {
      status: 'error',
      message: 'فیلد تاخیر الزامی است!',
    }
  }

  const res = await postFetchWithToken("/delays/store", form);
  if(res.status !== 'error'){
    return {
      status:'success',
      message:'تاخیر با موفقیت ایجاد شد'
    }
  }else{
    return {
      status:res.status,
      message:res.message
    }
  }
}
async function deleteDelays(id) {
  const res = await postFetchWithBody(`/delays/delete`, { id: id });
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
export { getDelays, storeDelays,deleteDelays };
